import { PostProperties } from "../types";
import image from "../img/exposeZemna.jpg";

const post: PostProperties = {
  id: 28,
  title: "Exposé 11 - Zemna",
  content:
    "Based in Bulgaria, she is a DJ that is involved in the local scene and loves to showcase her vast sounds. Zemna does not stick to one genre, as she prefers to explore her inner feelings and portray them with her selection. She believes that everyone needs to lose themselves in the music once in a while and turn off the outside world. In this mix, Zemna shows us exactly how to do that.",
  image,
  buttonText: "Read More",
  buttonUrl: "expose-11-zemna",
  category: "Expose",
  embedCode: `<iframe width="100%" height="600" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2233742741&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/shubinproject" title="Shubin" target="_blank" style="color: #cccccc; text-decoration: none;">Shubin</a> · <a href="https://soundcloud.com/shubinproject/expose-11-zemna" title="Exposé 11 - Zemna" target="_blank" style="color: #cccccc; text-decoration: none;">Exposé 11 - Zemna</a></div>`,
  questionsAndAnswers: [
    {
      question:
        "Tell us a little bit about yourself. How did your passion for electronic music start?",
      answer:
        "It all started about 4 years ago when I was introduced to electronic music. I've always been looking for 'my thing' and when I started listening to this music, I knew I had found it. I was lucky that my brother also likes this music and he showed me its beauty.",
    },
    {
      question:
        "As an artist, how would you describe your unique style and sound?",
      answer:
        "My style is a mirror of my deepest feelings. Those feelings you don't show to people. Dark, disturbing, sad, aggressive - that's my sound. It resonates with my inner world and helps me to express and heal myself.",
    },
    {
      question:
        "How do you discover new music and stay informed about emerging artists and styles?",
      answer:
        "Everyone knows - with a lot of digging. My friends showed me so many good places to find music.",
    },
    {
      question:
        "How has your local music scene influenced your music, and how do you contribute to its growth?",
      answer:
        "I am a big fan of the Bulgarian scene. I follow how it develops here more than abroad. I want to contribute to our scene, by introducing more people to this music and having more events in the country. Without commercialization and the goal of income, but for the sake of having a good time.",
    },
    {
      question: "What kind of impact do you hope your music has on listeners?",
      answer:
        "The impact I aim for is for people listening, whether on the dance floor or on their headphones, to relax and for a moment 'lose themselves' in the music. Everyone needs to stop for a moment and shake off the things that surround them and I believe that music is one of the best medicines.",
    },
    {
      question:
        "Can you share an unforgettable moment or experience from your music career that has deeply affected you as an artist?",
      answer:
        "I was at TABA record store recently for an in-store session and when I looked up at my friends and everyone else there, I noticed how everyone was smiling, dancing, or making sick faces to the track I was playing, and it warmed my heart. I don't care how many people are there, I just want to see that they're really connected to the vibe of the music I'm playing. I thought: Yes, that's what I want to see in my future.",
    },
    {
      question:
        "Can you tell us about any upcoming projects, releases, or performances you are currently working on?",
      answer:
        "I have some project in my mind and now I'm working on it. It's a set, where I'm going to unite video and ambient music. It sounds basic but my idea is the video that will be uploaded will be from footage that I have shot in the last few months. The footage is taken at times when I notice interesting things. 'The art of noticing', as some people say.",
    },
    {
      question: "Favourite DJ?",
      answer:
        "I can't say only one. At the moment they're Archon, Cinnamint, Markov, Karaul and Dreamdance from our local scene. I really like Sybil (UK), she caught my eye when I listened to her set at a Duna event.",
    },
    {
      question: "Favourite producer?",
      answer: "Magna Pia",
    },
    {
      question: "Favourite track?",
      answer: "James Ruskin - After dark",
    },
  ],
  translationsBg: {
    content:
      "Базирана в България, тя е DJ, активна в местната сцена, обичаща да представя разнообразния си звук. Zemna не се придържа към един жанр – предпочита да изследва вътрешните си усещания и да ги пресъздава чрез своята селекция. Тя вярва, че всеки понякога трябва да се изгуби в музиката и да изключи света около себе си. В този микс Zemna ни показва как точно се прави това.",
    questionsAndAnswers: [
      {
        question:
          "Разкажи ни малко за себе си. Как започна твоята страст към електронната музика?",
        answer:
          "Всичко започна преди около 4 години, когато се запознах с електронната музика. Винаги съм търсила 'своето нещо' и когато започнах да слушам тази музика, разбрах, че съм го намерила. Имах късмет, че и брат ми харесва тази музика и ми показа нейната красота.",
      },
      {
        question: "Как би описала уникалния си стил и звук като артист?",
        answer:
          "Моят стил е огледало на най-дълбоките ми чувства. Онези чувства, които не показваш на хората. Тъмни, смущаващи, тъжни, агресивни – такъв е моят звук. Резонира с вътрешния ми свят и ми помага да се изразя и изцелявам.",
      },
      {
        question:
          "Как откривате нова музика и следите за новите артисти и стилове?",
        answer:
          "Всеки знае – с много ровене. Приятелите ми ми показаха толкова добри места за намиране на музика.",
      },
      {
        question:
          "Как е повлияла местната музикална сцена на музиката ти и как допринасяш за нейното развитие?",
        answer:
          "Аз съм голям фен на българската сцена. Следя как се развива тук повече, отколкото в чужбина. Искам да допринасям за нашата сцена, като запозная повече хора с тази музика и организирам повече събития в страната. Без комерсиализация и стремеж към доходи, а заради самото удоволствие от добре прекарано време.",
      },
      {
        question:
          "Какво въздействие се надявате да окаже музиката ти върху слушателите?",
        answer:
          "Въздействието, към което се стремя, е хората – независимо дали на дансинга или с наушници – да се отпуснат и за миг да се 'изгубят' в музиката. Всеки от нас понякога трябва да спре и да се освободи от нещата около него, а аз вярвам, че музиката е едно от най-добрите лекарства.",
      },
      {
        question:
          "Можеш ли да споделиш незабравим момент или преживяване от музикалната си кариера, което дълбоко те е трогнало като артист?",
        answer:
          "Наскоро бях в TABA Record Store на in-store сесия и когато погледнах нагоре към приятелите ми и всички останали, забелязах, че всеки се усмихва, танцува или прави изражения на трака, който пусках, и сърцето ми се стопли. Не ме интересува колко хора са там – просто искам да видя, че наистина са свързани с вайба на музиката, която пускам. Помислих си: Да, ето това искам да виждам в бъдеще.",
      },
      {
        question:
          "Можеш ли да ни разкажеш за предстоящи проекти, издания или изпълнения, по които работиш в момента?",
        answer:
          "Имам един проект в ума си и в момента работя по него. Това е сет, в който ще обединя видео и амбиентна музика. Звучи базово, но идеята ми е видеото, което ще бъде качено, да включва материали, заснети от мен в последните няколко месеца – в моменти, когато забелязвам интересни неща. 'Изкуството да забелязваш', както казват някои хора.",
      },
      {
        question: "Любим DJ?",
        answer:
          "Не мога да назова само един. В момента са Archon, Cinnamint, Markov, Karaul и Dreamdance от нашата местна сцена. Много ми харесва и Sybil (UK) – тя ми привлече вниманието, когато слушах сета й на събитие на Duna.",
      },
      {
        question: "Любим продуцент?",
        answer: "Magna Pia",
      },
      {
        question: "Любим трак?",
        answer: "James Ruskin - After dark",
      },
    ],
  },
};

export default post;
